import { Tooltip, Space, Popconfirm, Tag, Switch, Flex, Typography, Avatar } from "antd";
import { EditTwoTone, DeleteTwoTone } from "@ant-design/icons";
import get from "lodash/get";
import find from "lodash/find";
import { COLOR_PRIMARY } from "..";
import { USER_ROLES } from "../userRoles";
import { includes } from "lodash";

const { Text } = Typography;

const getRoleConfig = (role) =>
  find(USER_ROLES, (roleObj) => includes(get(roleObj, "ids"), get(role, "id")));

const UserAvatar = ({ name, color }) => {
  const initials = name && typeof name === "string" ? trimInitials(name) : "--";
  return (
    <Avatar
      size={32}
      style={{
        backgroundColor: color || COLOR_PRIMARY,
        color: "#FFFFFF",
        fontWeight: 600,
        fontSize: "0.85em",
        flexShrink: 0,
      }}
    >
      {initials}
    </Avatar>
  );
};

const trimInitials = (name) => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const userColumns = (toggleUserForm, onDeleteUser, onToggleStatus) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (name, record) => {
      const roleConfig = getRoleConfig(get(record, "role"));
      return (
        <Flex align="center" gap={10}>
          <UserAvatar name={name} color={get(roleConfig, "avatarColor")} />
          <Text>{name}</Text>
        </Flex>
      );
    },
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    render: (role) => {
      const roleConfig = find(USER_ROLES, (roleObj) => {
        return includes(get(roleObj, 'ids'), get(role, 'id'))
      });
      return (
        <Tag color={get(roleConfig, 'color')} className="min-w-36 text-center">
          {get(roleConfig, 'label')}
        </Tag>
      );
    },
  },
  {
    title: "Status",
    dataIndex: "enabled",
    key: "status",
    align: "center",
    render: (status, record) => (
      <Flex justify="center" align="center">
        <Switch
          size="small"
          checked={status}
          onChange={(value) => onToggleStatus(record, value)}
          checkedChildren={
            <Text className="text-white" style={{ fontSize: "10px" }}>
              Active
            </Text>
          }
          unCheckedChildren={
            <Text className="text-white" style={{ fontSize: "10px" }}>
              Inactive
            </Text>
          }
        />
      </Flex>
    ),
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    render: (record) => {
      return (
        <Space size="middle">
          <Tooltip title="Edit User">
            <EditTwoTone
              style={{ fontSize: 20 }}
              twoToneColor={COLOR_PRIMARY}
              onClick={() => {
                toggleUserForm(record, true);
              }}
            />
          </Tooltip>

          <Tooltip title="Delete User">
            <Popconfirm
              title="Delete the User"
              description="Are you sure to delete this User?"
              onConfirm={() => {
                onDeleteUser(get(record, "id"));
              }}
              okText="Yes"
              cancelText="No"
            >
              <DeleteTwoTone style={{ fontSize: 20 }} twoToneColor={COLOR_PRIMARY} />
            </Popconfirm>
          </Tooltip>
        </Space>
      );
    },
  },
];
